// import React from 'react';
import { styled } from '@mui/material/styles';
import { smartGovernanceOff, smartGovernanceOn } from 'kosmos/images';

const PREFIX = 'SmartGovernanceVerificationLogo';

const classes = {
  icon: `${PREFIX}-icon`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  [`& .${classes.icon}`]: {
    borderRadius: 4,
  },
  [`&.inactive .${classes.icon}`]: {
    borderRadius: 4,
    width: '100%',
  },
}));

interface IProps {
  active: boolean;
}

export default function SmartGovernanceVerificationLogo(props: IProps): JSX.Element {
  const { active } = props;
  const renderIcon = () => {
    const src = active ? smartGovernanceOn : smartGovernanceOff;
    return <img src={src} className={classes.icon} />;
  };

  return <Root className={active ? 'active' : 'inactive'}>{renderIcon()}</Root>;
}
